import moment from 'moment';
import { isValidElement } from 'react';
import countries from 'world-countries';

export const isNotNull = (inputValue: string): boolean => {
    if (inputValue === null || inputValue === undefined) {
        return false;
    } else {
        return inputValue.length > 0;
    }
};

// -----------------------------------------------------------------

export const isNotEmpty = (inputValue: string): boolean => {
    if (inputValue === null || inputValue === undefined || inputValue === '') {
        return false;
    } else {
        return inputValue.length > 0;
    }
};

// -----------------------------------------------------------------

export const hasMinimumLength = (inputValue: string, minLength: number): boolean => {
    return inputValue.length >= minLength;
};

// -----------------------------------------------------------------

export const hasExactLength = (inputValue: string, length: number): boolean => {
    return inputValue.length === length;
};

// -----------------------------------------------------------------

export const hasMaxLength = (inputValue: string, length: number): boolean => {
    return inputValue.length <= length;
};

// -----------------------------------------------------------------

export const isAccepted = (inputValue: boolean): boolean => {
    return inputValue === true;
};

// -----------------------------------------------------------------

export const isValidEmailAddress = (inputValue: string): boolean => {
    //const regex =
    //    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    //const regex = /^(?!.*\.\.)[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)+$/
    const regex = /^(?!.*\.\.)[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)+$/


    return regex.test(inputValue);
};


// return /^(?!.*\.\.)[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)+$/.test(email);


// ----------------------------------------------------------------

export const phoneNumberStatusIsValid = (status: boolean): boolean => {
    return status;
};

// ----------------------------------------------------------------

export const isNumber = (status: any): boolean => {
    return !isNaN(status);
};

// ----------------------------------------------------------------

export const hasNoValidationErrors = (errors: Object): boolean => {
    let isValid = true;
    Object.values(errors).forEach((error) => {
        if (error !== null && typeof error === 'object' && !isValidElement(error)) {
            isValid = hasNoValidationErrors(error);
        } else if (error !== null) {
            isValid = false;
        }
    });
    return isValid;
};

// -----------------------------------------------------------------

export const isNotZero = (inputValue: number): boolean => {
    return inputValue !== 0;
};

// -----------------------------------------------------------------

export const expiryDateIsInFuture = (expiry: string): boolean => {
    if (expiry.length < 5) {
        return false;
    }
    const expiryDate = moment(expiry, 'MM-YY');
    const lastDayOfExpiryMonth = moment(expiryDate).endOf('month');
    const today = moment();
    return moment(lastDayOfExpiryMonth).isAfter(today);
};

// -----------------------------------------------------------------

export const startsWithCountryCode = (inputValue: string): boolean => {
    const countryCodes = countries.map((country) => country.cca2);
    const first2CharactersFromInput = inputValue.slice(0, 2);
    return countryCodes.includes(first2CharactersFromInput);
};

// -----------------------------------------------------------------

export const isValidVAT = (inputValue: string): boolean => {
    const REGEX_VAT = new RegExp(
        '^(ATU[0-9]{8}|BE0[0-9]{9}|BG[0-9]{9,10}|CY[0-9]{8}L|CZ[0-9]{8,10}|DE[0-9]{9}|DK[0-9]{8}|EE[0-9]{9}|(EL|GR)[0-9]{9}|ES[0-9A-Z][0-9]{7}[0-9A-Z]|FI[0-9]{8}|FR[0-9A-Z]{2}[0-9]{9}|GB([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})|HU[0-9]{8}|IE[0-9]S[0-9]{5}L|IT[0-9]{11}|LT([0-9]{9}|[0-9]{12})|LU[0-9]{8}|LV[0-9]{11}|MT[0-9]{8}|NL[0-9]{9}B[0-9]{2}|PL[0-9]{10}|PT[0-9]{9}|RO[0-9]{2,10}|SE[0-9]{12}|SI[0-9]{8}|SK[0-9]{10})$'
    );

    return REGEX_VAT.test(inputValue);
};

// -----------------------------------------------------------------
